import { render, staticRenderFns } from "./PlacementTypesDropdownList.vue?vue&type=template&id=90e7a7f4"
import script from "./PlacementTypesDropdownList.vue?vue&type=script&lang=js"
export * from "./PlacementTypesDropdownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports